import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination } from '@/types';
import { OrganizationsService } from '../../../services';
import ModelAccreditationGetters from './getters';
import ModelAccreditationMutations from './mutations';
import ModelAccreditationState from './state';

const organizationsService = new OrganizationsService();

export default class ModelAccreditationActions extends Actions<
  ModelAccreditationState,
  ModelAccreditationGetters,
  ModelAccreditationMutations,
  // eslint-disable-next-line no-use-before-define
  ModelAccreditationActions
> {
  async get_model_accreditation(id: string | number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters_accreditation,
        pagination: {
          limit: itemsPerPage,
          page,
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_MODEL_ACCREDITATION(true);
      const { data, meta } = await organizationsService.get_model_accreditation(id, payload);

      this.mutations.SET_MODEL_ACCREDITATION(data.items);
      this.mutations.SET_ACCREDITED_COUNT(data.accredited_count);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
      return data;
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING_MODEL_ACCREDITATION(false);
    }
  }
}
